import { PageHeader, PageHeaderProps } from '@ant-design/pro-components';
import { Card, Layout, theme } from 'antd';
import { FC, ReactNode, createContext, memo, useRef, useState } from 'react';
import { ArrowLeftCircle } from 'react-bootstrap-icons';

import './CommonContainer.scss';

interface Props {
  children: ReactNode;
}

export const CommonContainerContext = createContext({
  title: null as PageHeaderProps['title'],
  extra: null as PageHeaderProps['extra'],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setTitle: (node: PageHeaderProps['title']) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setExtra: (node: PageHeaderProps['extra']) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setBackAction: (backAction: PageHeaderProps['onBack']) => {}
});

export const CommonLayoutContainer: FC<Props> = memo(({ children }) => {
  const { token } = theme.useToken();
  const { colorBgLayout } = theme.useToken().token;

  const mainRef = useRef(null);

  const [containerTitle, setContainerTitle] = useState<PageHeaderProps['title']>(null);
  const [containerExtra, setContainerExtra] = useState<PageHeaderProps['extra']>(null);
  const [back, setBack] = useState<PageHeaderProps['onBack'] | undefined>(undefined);

  const handleSetTitle = (node: PageHeaderProps['title']): void => {
    setContainerTitle(node);
  };

  const handleSetExtra = (node: PageHeaderProps['extra']): void => {
    setContainerExtra(node);
  };

  const handleSetBackAction = (backAction: PageHeaderProps['onBack']): void => {
    setBack(() => backAction);
  };

  return (
    <CommonContainerContext.Provider
      value={{
        title: containerTitle,
        extra: containerTitle,
        setExtra: handleSetExtra,
        setTitle: handleSetTitle,
        setBackAction: handleSetBackAction
      }}
    >
      <Layout.Content className="common-layout__container" style={{ backgroundColor: colorBgLayout }} ref={ mainRef } >
        <Card
          styles={{
            header: {
              borderBottom: `1px solid ${ token.colorBorder }`,
              backgroundColor: colorBgLayout,
              position: 'sticky',
              top: 0,
              zIndex: 1000,
              transition: 'min-height 0.06s linear'
            }
          }}
          style={{ background: 'transparent', border: 'none' }}
          title={
            <div style={{ margin: '0 auto', maxWidth: '1350px' }}>
              <PageHeader
                onBack={ back }
                backIcon={ back ? <ArrowLeftCircle size={ 24 }/> : false }
                title={ containerTitle ?? <>&nbsp;</> }
                extra={ containerExtra }
              />
            </div>
          }
        >
          <div style={{ margin: '0 auto', maxWidth: '1350px' }}>
            { children }
          </div>
        </Card>
      </Layout.Content>
    </CommonContainerContext.Provider>
  );
});
